import { v4 as uuid } from "uuid";
import { i18n } from "../pages/private/languageSelector";
const config = {
  VERSION: "1",
};
export const AUTH_TOKEN_KEY = "tamam-authenticationToken";

export const LANGUAGE = "language";

// Default placeholder form image. Env-driven so a staging build can point at its
// own bucket; falls back to the prod bucket asset when unset (behavior unchanged).
export const DEFAULT_FORM_IMAGE =
  import.meta.env.REACT_APP_DEFAULT_FORM_IMAGE ||
  "https://tamam-uploads-prod.s3.ap-south-1.amazonaws.com/ee6023bcb103ac283cbe79ec86d16323.png";

export const COLOR_TAGS = [
  "tag-green",
  "tag-yellow",
  "tag-red",
  "tag-gray",
  "tag-blue",
  "tag-pink",
  "tag-blue-light",
  "tag-slate",
];

export const SEATS_SELECT = [
  { label: "Seated User", value: true },
  { label: "Unseated User", value: false },
];

export const MULTIPLE_CHOICE_RESPONSES = [
  {
    options: [
      {
        name: "Yes",
        class: "tag-green",
        score: 1,
        canComment: false,
        canAttachPhoto: false,
        isFail: false,
      },
      {
        name: "No",
        class: "tag-red",
        score: 0,
        canComment: false,
        canAttachPhoto: false,
        isFail: true,
      },
      {
        name: "N/A",
        class: "tag-slate",
        score: "-",
        canComment: false,
        canAttachPhoto: false,
        isFail: false,
      },
    ],
  },
  {
    options: [
      {
        name: "Good",
        class: "tag-green",
        score: 1,
        canComment: false,
        canAttachPhoto: false,
        isFail: false,
      },
      {
        name: "Fair",
        class: "tag-yellow",
        score: "-",
        canComment: false,
        canAttachPhoto: false,
        isFail: false,
      },
      {
        name: "Poor",
        class: "tag-red",
        score: 0,
        canComment: false,
        canAttachPhoto: false,
        isFail: true,
      },
      {
        name: "N/A",
        class: "tag-slate",
        score: "-",
        canComment: false,
        canAttachPhoto: false,
        isFail: false,
      },
    ],
  },
  {
    options: [
      {
        name: "Safe",
        class: "tag-green",
        score: 1,
        canComment: false,
        canAttachPhoto: false,
        isFail: false,
      },
      {
        name: "Risk",
        class: "tag-red",
        score: 0,
        canComment: false,
        canAttachPhoto: false,
        isFail: true,
      },
      {
        name: "N/A",
        class: "tag-slate",
        score: "-",
        canComment: false,
        canAttachPhoto: false,
        isFail: false,
      },
    ],
  },
  {
    options: [
      {
        name: "Pass",
        class: "tag-green",
        score: 1,
        canComment: false,
        canAttachPhoto: false,
        isFail: false,
      },
      {
        name: "Fail",
        class: "tag-red",
        score: 0,
        canComment: false,
        canAttachPhoto: false,
        isFail: true,
      },
      {
        name: "N/A",
        class: "tag-slate",
        score: "-",
        canComment: false,
        canAttachPhoto: false,
        isFail: false,
      },
    ],
  },
  {
    options: [
      {
        name: "Compliant",
        class: "tag-green",
        score: 1,
        canComment: false,
        canAttachPhoto: false,
        isFail: false,
      },
      {
        name: "Non-Compliant",
        class: "tag-red",
        score: 0,
        canComment: false,
        canAttachPhoto: false,
        isFail: true,
      },
      {
        name: "N/A",
        class: "tag-slate",
        score: "-",
        canComment: false,
        canAttachPhoto: false,
        isFail: false,
      },
    ],
  },
  {
    options: [
      {
        name: "N/A",
        class: "tag-slate",
        score: "-",
        canComment: false,
        canAttachPhoto: false,
        isFail: false,
      },
    ],
  },
  {
    options: [
      {
        name: "Enter Response",
        class: "tag-slate",
        score: "-",
        canComment: false,
        canAttachPhoto: false,
        isFail: false,
      },
    ],
  },
];

export const RESPONSES_TYPES = {
  MULTIPLE_CHOICE_RESPONSE_V1: {
    name: "Multiple choices",
    type: "COMPLEX_MULTIPLE_CHOICE",
    questionUuid: uuid(),
    settings: {
      isOpen: true,
      questionText: "Add a new question",
      questionPlaceHolder: "Add a new question",
      isEnabled: true,
      isMandatory: false,
      score: 1,
      description: "",
      photo: "",
      selectionType: "SINGLE",
      answers: [...MULTIPLE_CHOICE_RESPONSES[0].options],
    },
  },
  MULTIPLE_CHOICE_RESPONSE_V2: {
    name: "Multiple choices",
    type: "COMPLEX_MULTIPLE_CHOICE",
    questionUuid: uuid(),
    settings: {
      isOpen: true,
      questionText: "Add a new question",
      questionPlaceHolder: "Add a new question",
      isEnabled: true,
      isMandatory: false,
      score: 1,
      description: "",
      photo: "",
      selectionType: "SINGLE",
      answers: [...MULTIPLE_CHOICE_RESPONSES[1].options],
    },
  },
  MULTIPLE_CHOICE_RESPONSE_V3: {
    name: "Multiple choices",
    type: "COMPLEX_MULTIPLE_CHOICE",
    questionUuid: uuid(),
    settings: {
      isOpen: true,
      questionText: "Add a new question",
      questionPlaceHolder: "Add a new question",
      isEnabled: true,
      isMandatory: false,
      score: 1,
      description: "",
      photo: "",
      selectionType: "SINGLE",
      answers: [...MULTIPLE_CHOICE_RESPONSES[2].options],
    },
  },
  MULTIPLE_CHOICE_RESPONSE_V4: {
    name: "Multiple choices",
    type: "COMPLEX_MULTIPLE_CHOICE",
    questionUuid: uuid(),
    settings: {
      isOpen: true,
      questionText: "Add a new question",
      questionPlaceHolder: "Add a new question",
      isEnabled: true,
      isMandatory: false,
      score: 1,
      description: "",
      photo: "",
      selectionType: "SINGLE",
      answers: [...MULTIPLE_CHOICE_RESPONSES[3].options],
    },
  },
  MULTIPLE_CHOICE_RESPONSE_V5: {
    name: "Multiple choices",
    type: "COMPLEX_MULTIPLE_CHOICE",
    questionUuid: uuid(),
    settings: {
      isOpen: true,
      questionText: "Add a new question",
      questionPlaceHolder: "Add a new question",
      isEnabled: true,
      isMandatory: false,
      score: 1,
      description: "",
      photo: "",
      selectionType: "SINGLE",
      answers: [...MULTIPLE_CHOICE_RESPONSES[4].options],
    },
  },
  MULTIPLE_CHOICE_RESPONSE_V6: {
    name: "Multiple choices",
    type: "COMPLEX_MULTIPLE_CHOICE",
    questionUuid: uuid(),
    settings: {
      isOpen: true,
      questionText: "Add a new question",
      questionPlaceHolder: "Add a new question",
      isEnabled: true,
      isMandatory: false,
      score: 1,
      description: "",
      photo: "",
      selectionType: "SINGLE",
      answers: [...MULTIPLE_CHOICE_RESPONSES[5].options],
    },
  },
  MULTIPLE_CHOICE_RESPONSE_V7: {
    name: "Multiple choices",
    type: "COMPLEX_MULTIPLE_CHOICE",
    questionUuid: uuid(),
    settings: {
      isOpen: true,
      questionText: "Add a new question",
      questionPlaceHolder: "Add a new question",
      isEnabled: true,
      isMandatory: false,
      score: 1,
      description: "",
      photo: "",
      selectionType: "SINGLE",
      answers: [...MULTIPLE_CHOICE_RESPONSES[6].options],
    },
  },
  TEXT: {
    name: "Text Answer",
    type: "text",
    questionUuid: uuid(),
    settings: {
      isOpen: true,
      questionText: "Add a new question",
      questionPlaceHolder: "Add a new question",
      canComment: false,
      canAttachPhoto: false,
      // isFail: false,
      isEnabled: true,
      isMandatory: false,
      score: 0,
      description: "",
      photo: "",
      textType: "SINGLE_LINE",
      answers: "",
    },
  },
  NUMBER: {
    name: "Number",
    type: "number",
    questionUuid: uuid(),
    settings: {
      isOpen: true,
      questionText: "Add a new question",
      questionPlaceHolder: "Add a new question",
      canComment: false,
      canAttachPhoto: false,
      isFail: false,
      isEnabled: true,
      isMandatory: false,
      score: 0,
      description: "",
      photo: "",
      min: "5",
      max: "10",
      comparisionOptions: [
        "Between",
        "More than",
        "More than or equals",
        "Equals",
        "Less than or equals",
        "Less than",
      ],
      comparision: "More than",
      measurement: "CENTIGRAGE",
      numberType: "NUMBER",
      answers: "",
    },
  },
  CHECKBOX: {
    name: "Checkbox",
    type: "checkbox",
    questionUuid: uuid(),
    settings: {
      isOpen: true,
      questionText: "Add a new question",
      questionPlaceHolder: "Add a new question",
      canComment: false,
      canAttachPhoto: false,
      // isFail: false,
      isEnabled: true,
      isMandatory: false,
      score: 1,
      description: "",
      photo: "",
      answers: "",
    },
  },
  DATE_AND_TIME: {
    name: "Date & Time",
    type: "date time",
    questionUuid: uuid(),
    settings: {
      isOpen: true,
      questionText: "Add a new question",
      questionPlaceHolder: "Add a new question",
      canComment: false,
      canAttachPhoto: false,
      // isFail: false,
      isEnabled: true,
      isMandatory: false,
      score: 0,
      description: "",
      photo: "",
      isDate: true,
      isTime: true,
      answers: "",
    },
  },
  IMAGE: {
    name: "Image",
    type: "image",
    questionUuid: uuid(),
    settings: {
      isOpen: true,
      questionText: "Add a new question",
      questionPlaceHolder: "Add a new question",
      canComment: false,
      canAttachPhoto: false,
      // isFail: false,
      isEnabled: true,
      isMandatory: false,
      score: 0,
      description: "",
      photo: "",
      isOnlyCamera: false,
      fileTypes: ["png", "jpg", "jpeg"],
      answers: "",
    },
  },
  PDF: {
    name: "PDF",
    type: "pdf",
    questionUuid: uuid(),
    settings: {
      isOpen: true,
      questionText: "Add a new question",
      questionPlaceHolder: "Add a new question",
      canComment: false,
      canAttachPhoto: false,
      // isFail: false,
      isEnabled: true,
      isMandatory: false,
      score: 0,
      description: "",
      photo: "",
      fileTypes: ["pdf"],
      answers: "",
      selectedFile: "",
    },
  },
  SLIDER: {
    name: "Slider",
    type: "slider",
    questionUuid: uuid(),
    settings: {
      isOpen: true,
      questionText: "Add a new question",
      questionPlaceHolder: "Add a new question",
      canComment: false,
      canAttachPhoto: false,
      // isFail: false,
      isEnabled: true,
      isMandatory: false,
      score: 1,
      description: "",
      photo: "",
      min: 0,
      max: 10,
      increment: 1,
      answers: "",
    },
  },
  INSTRUCTIONS: {
    name: "Instructions",
    type: "instructions",
    questionUuid: uuid(),
    settings: {
      isOpen: true,
      questionText: "Enter Instructions",
      questionPlaceHolder: "Enter Instructions",
      isEnabled: true,
      score: 0,
      description: "",
      photo: "",
      selectedFile: "",
      selectedFileName: "",
      answers: "",
    },
  },
  LOCATION: {
    name: "Location",
    type: "location",
    questionUuid: uuid(),
    settings: {
      isOpen: true,
      questionText: "Add a new question",
      questionPlaceHolder: "Add a new question",
      canComment: false,
      canAttachPhoto: false,
      // isFail: false,
      isEnabled: true,
      isMandatory: false,
      score: 0,
      description: "",
      photo: "",
      answers: "",
    },
  },
  SIGNATURE: {
    name: "Signature",
    type: "signature",
    questionUuid: uuid(),
    settings: {
      isOpen: true,
      questionText: "Add a new question",
      questionPlaceHolder: "Add a new question",
      isEnabled: true,
      isMandatory: false,
      score: 0,
      description: "",
      photo: "",
      answers: "",
    },
  },
  DROP_DOWN_LIST: {
    name: "Dropdown",
    type: "DROPDOWN",
    questionUuid: uuid(),
    settings: {
      isOpen: true,
      questionText: "Add a new question",
      questionPlaceHolder: "Add a new question",
      canComment: false,
      canAttachPhoto: false,
      // isFail: false,
      isEnabled: true,
      isMandatory: false,
      score: 0,
      description: "",
      photo: "",
      selectionType: "SINGLE",
      listName: "",
      options: [],
      answers: "",
    },
  },
};

export default config;

export const SERVER_API_URL = import.meta.env.REACT_APP_SERVER_URL;
export const SERVER_ENV = import.meta.env.REACT_APP_MODE;

export const APP_DATE_FORMAT = "DD/MM/YY HH:mm";
export const APP_TIMESTAMP_FORMAT = "DD/MM/YY HH:mm:ss";
export const APP_LOCAL_DATE_FORMAT = "DD/MM/YYYY";
export const APP_LOCAL_DATETIME_FORMAT = "YYYY-MM-DDTHH:mm";
export const APP_LOCAL_DATETIME_FORMAT_Z = "YYYY-MM-DDTHH:mm Z";
export const APP_WHOLE_NUMBER_FORMAT = "0,0";
export const APP_TWO_DIGITS_AFTER_POINT_NUMBER_FORMAT = "0,0.[00]";
export const COMPANY_INDUSTORY_DROPDOWN = [
  { value: "Agriculture", label: "Agriculture" },
  { value: "Cleaning", label: "Cleaning" },
  { value: "Community services", label: "Community services" },
  { value: "Construction", label: "Construction" },
  { value: "Education", label: "Education" },
  { value: "Emergency services", label: "Emergency services" },
  { value: "Financial services", label: "Financial services" },
  { value: "Food and Beverages", label: "Food and Beverages" },
  { value: "General", label: "General" },
  { value: "Health services", label: "Health services" },
  { value: "Hospitality", label: "Hospitality" },
  { value: "ICT", label: "ICT" },
  { value: "Manufacturing", label: "Manufacturing" },
  { value: "Mining", label: "Mining" },
  { value: "Professional services", label: "Professional services" },
  { value: "Publishing", label: "Publishing" },
  {
    value: "Transport and logistics",
    label: "Transport and logistics",
  },
];

export const COMPANY_NUMBER_OF_EMPLOYEES = [
  { value: "1--5", label: "1--5" },
  { value: "6--19", label: "6--19" },
  { value: "20--49", label: "20--49" },
  { value: "50--99", label: "50--99" },
  { value: "100--199", label: "100--199" },
  { value: "200--499", label: "200--499" },
  { value: "500--2999", label: "500--2999" },
  { value: "3000 and More", label: "3000 and More" },
];

export const REPORT_STATUS_FILTER = [
  { value: "reSubmit", lable: "ReSubmit" },
  { value: "submit", lable: "Submit" },
  { value: "accept", lable: "Accept" },
  { value: "reject", lable: "Reject" },
  { value: "incomplete", lable: "Incomplete" },
  { value: "draft", lable: "Draft" },
];

export const REPORT_COLORS = [
  { value: false, label: "theme-gray-one" },
  { value: false, label: "theme-gray-two" },
  { value: false, label: "theme-gray-three" },
  { value: false, label: "theme-primary-one" },
  { value: false, label: "theme-primary-two" },
  { value: false, label: "theme-primary-three" },
  { value: false, label: "theme-green-one" },
  { value: false, label: "theme-green-two" },
  { value: false, label: "theme-green-three" },
  { value: false, label: "theme-red" },
  { value: false, label: "theme-orange" },
  { value: false, label: "theme-yellow" },
  { value: false, label: "theme-purple-one" },
  { value: false, label: "theme-purple-two" },
  { value: false, label: "theme-pink" },
];
export const settingInitState = {
  title: {
    siteName: true,
    inspectorName: true,
    dateTime: true,
  },
  content: {
    scores: true,
    failsCount: true,
    docNumber: true,
    dateTime: true,
    created: true,
    lastUpdate: true,
    conducted: true,
    failsSummary: true,
    instructions: true,
    unAnsweredQuestions: true,
    inspectionQuestions: true,
    answered: false,
    unAnswered: false,
    all: true,
    photos: false,
    standardQuality: true,
    highQuality: false,
    photosLinksQrCode: true,
    PdfLinksQrCode: true,
    tableOfContents: true,
    companyInformation: true,
    disclaimer: "",
    footer: {
      page: true,
      title: true,
      date: true,
      inspectorName: true,
    },
  },
};

export const INPUT_VALUES_TO_EXCLUDE = [
  "+",
  "-",
  ",",
  "`",
  "/",
  "|",
  "!",
  "@",
  "#",
  "$",
  "%",
  "^",
  "&",
  "*",
  "_",
  "(",
  ")",
  "?",
  "[",
  "]",
  "{",
  "}",
  ">",
  "<",
  "'",
  ";",
  ":",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
];

export const DUMMY_ANALYTICS_TABLE_DATA = [
  {
    id: 1,
    report: "Jeddah - Yasser Nemer - 21 Aug 2023",
    date: "21 Aug 2023",
    form: "Safety first",
    inspector: "Yasser Nemer",
    site: "Jeddah",
    fail: 1,
    score: 75.98,
    completion: 99.01,
    status: "Complete",
  },
  {
    id: 2,
    report: "Qatif - Abdulla ali - 20 Aug 2023",
    date: "20 Aug 2023",
    form: "Dispatch Notification Test",
    inspector: "Abdulla Ali",
    site: "Qatif",
    fail: 7,
    score: 96.23,
    completion: 87.36,
    status: "Draft",
  },
  {
    id: 3,
    report: "Default Site - Hani Alnasser - 19 Aug 2023",
    date: "19 Aug 2023",
    form: "Cleaning",
    inspector: "Hani Alnasser",
    site: "Default Site",
    fail: 8,
    score: 0,
    completion: 77.0,
    status: "Incomplete",
  },
  {
    id: 4,
    report: "Jeddah  - Yasser Nemer - 18 Aug 2023",
    date: "18 Aug 2023",
    form: "Multi-Select Fail Test",
    inspector: "Yasser Nemer",
    site: "Jeddah",
    fail: 9,
    score: 0,
    completion: 57.65,
    status: "Rejected",
  },
  {
    id: 5,
    report: "Default Site - Nasser Ahmed - 16 Aug 2023",
    date: "17 Aug 2023",
    form: "Safety first",
    inspector: "Nasser Ahmed",
    site: "Default Site",
    fail: 4,
    score: 66.85,
    completion: 25.36,
    status: "Resubmitted",
  },
  {
    id: 6,
    report: "Default Site - Abdulla Ali - 15 Aug 2023",
    date: "15 Aug 2023",
    form: "Cleaning",
    inspector: "Abdulla Ali",
    site: "Default Site",
    fail: 7,
    score: 69.65,
    completion: 70.0,
    status: "Submitted",
  },
  {
    id: 7,
    report: "Qatif - Yasser Nemer - 14 Aug 2023",
    date: "14 Aug 2023",
    form: "Dispatch Notification Test",
    inspector: "Yasser Nemer",
    site: "Qatif",
    fail: 13,
    score: 0,
    completion: 78.23,
    status: "Complete",
  },
  {
    id: 8,
    report: "Default Site - Hani Alnasser - 13 Aug 2023",
    date: "13 Aug 2023",
    form: "Quality and health",
    inspector: "Hani Alnasser",
    site: "Default Site",
    fail: 2,
    score: 78.38,
    completion: 68.33,
    status: "Complete",
  },
  {
    id: 9,
    report: "Jeddah - Nasser Ahmed - 12Aug 2023",
    date: "12 Aug 2023",
    form: "Safety first",
    inspector: "Nasser Ahmed",
    site: "Jeddah",
    fail: 0,
    score: 45.65,
    completion: 68.33,
    status: "Complete",
  },
];

export const subscriptionsTranslation = (text: any) => {
  if (text === "Free") {
    return i18n("global.Free");
  } else if (text === "Trial") {
    return i18n("Subscriptions.Trial");
  } else if (text === "Monthly Subscription") {
    return i18n("Subscriptions.MonthlySubscription");
  } else if (text === "Yearly Subscription") {
    return i18n("Subscriptions.YearlySubscription");
  } else if (text === "Running") {
    return i18n("Subscriptions.Running");
  } else if (text === "Expired") {
    return i18n("Subscriptions.Expired");
  } else if (text === "Trial is running") {
    return i18n("Subscriptions.TrialIsRunning");
  } else if (text === "Unsubscribed, subscription is running") {
    return i18n("Subscriptions.UnsubscribedSubscriptionRunning");
  } else if (text === "Paused") {
    return i18n("Subscriptions.Paused");
  } else if (text === "Additional seats") {
    return i18n("Subscriptions.AdditionalSeats");
  }
};

export const invoiceTranslation = (text: any) => {
  if (text === "Monthly Subscription") {
    return i18n("Subscriptions.MonthlyInvoice");
  } else if (text === "Yearly Subscription") {
    return i18n("Subscriptions.YearlyInvoice");
  } else if (text === "Additional seats") {
    return i18n("Subscriptions.AdditionalSeatsInvoice");
  }
};

export const companyPaymentCardTranslation = (text: any) => {
  if (text === "visa") {
    return i18n("Subscriptions.Visa");
  } else if (text === "master") {
    return i18n("Subscriptions.master");
  } else if (text === "American Express") {
    return i18n("Subscriptions.AmericanExpress");
  } else if (text === "Discover") {
    return i18n("Subscriptions.Discover");
  } else if (text === "DinersClub") {
    return i18n("Subscriptions.DinersClub");
  } else if (text === "JCB") {
    return i18n("Subscriptions.JCB");
  } else if (text === "UnionPay") {
    return i18n("Subscriptions.UnionPay");
  } else if (text === "Unexpected Failure") {
    return i18n("Subscriptions.UnexpectedFailure");
  } else if (text === "Insufficient Funds") {
    return i18n("Subscriptions.InsufficientFunds");
  } else if (text === "Card Declined") {
    return i18n("Subscriptions.CardDeclined");
  } else if (
    text ===
    "There was an unexpected issue with your card. Please try again or use a different card."
  ) {
    return i18n(
      "Subscriptions.ThereWasAnUnexpectedIssueWithYourCardPleaseTryAgainORUseDifferentCard",
    );
  } else if (
    text ===
    "There are insufficient funds on your card. Please try a different card or add funds to your account."
  ) {
    return i18n(
      "Subscriptions.ThereAreInsufficientFundsOnYourCardPleaseTryDifferentCardORAddFundsToYourAccount",
    );
  } else if (
    text ===
    "Your card was declined. Please use a different card or contact your bank for more information."
  ) {
    return i18n(
      "Subscriptions.YourCardWasDeclinedPleaseUseDifferentCardORContactYourBankForMoreInformation",
    );
  }
};

export const checkIsTrialRunning = (subscriptionData: any) => {
  return (
    subscriptionData?.currentPlan?.plan === "Trial" &&
    subscriptionData?.currentPlan?.status === "Running" &&
    subscriptionData?.userTrial?.isTrialStarted &&
    !subscriptionData?.userTrial?.isTrialCancelled &&
    !subscriptionData?.userTrial?.isTrialExpired
  );
};

export const checkIsTrialExpired = (subscriptionData: any) => {
  return (
    subscriptionData?.userTrial?.isTrialExpired &&
    subscriptionData?.currentPlan?.status === "Expired" &&
    !subscriptionData?.subscriptionInfo?.isSubscribed
  );
};

export const checkUserInFreePlan = (subscriptionData: any) => {
  return (
    subscriptionData?.currentPlan?.plan === "Free" &&
    subscriptionData?.currentPlan?.status === "Free" &&
    !subscriptionData?.userTrial?.isTrialStarted &&
    !subscriptionData?.userTrial?.isTrialCancelled &&
    !subscriptionData?.userTrial?.isTrialExpired
  );
};

export const checkIsSubscriptionExpired = (subscriptionData: any) => {
  return (
    subscriptionData?.currentPlan?.status === "Expired" &&
    subscriptionData?.subscriptionInfo?.isSubscribed &&
    subscriptionData?.subscriptionInfo?.isUnsubscribed &&
    subscriptionData?.subscriptionInfo?.isSubscribedExpired
  );
};

export const checkIsTrialCancelled = (subscriptionData: any) => {
  return (
    subscriptionData?.currentPlan?.plan === "Free" &&
    subscriptionData?.currentPlan?.status === "Free" &&
    subscriptionData?.userTrial?.isTrialCancelled &&
    subscriptionData?.userTrial?.isTrialExpired
  );
};

export const checkIsSubscriptionRunning = (subscriptionData: any) => {
  return (
    (subscriptionData?.currentPlan?.plan === "Monthly Subscription" ||
      subscriptionData?.currentPlan?.plan === "Yearly Subscription") &&
    subscriptionData?.subscriptionInfo?.isSubscribed &&
    subscriptionData?.subscriptionEndedAt &&
    subscriptionData?.subscriptionStartedAt
  );
};

export const checkForUpdateLastSubscriptionDataWhileSubscriptionTrialIsRunning =
  (subscriptionData: any) => {
    return (
      subscriptionData?.currentPlan?.status === "Trial is running" &&
      subscriptionData?.userTrial?.isTrialStarted &&
      !subscriptionData?.userTrial?.isTrialCancelled &&
      !subscriptionData?.userTrial?.isTrialExpired &&
      subscriptionData?.subscriptionInfo?.isSubscribed
    );
  };

export const checkIsTrialSubscriptionRunning = (subscriptionData: any) => {
  return (
    subscriptionData?.currentPlan?.status === "Trial is running" &&
    subscriptionData?.userTrial?.isTrialStarted &&
    !subscriptionData?.userTrial?.isTrialExpired &&
    !subscriptionData?.userTrial?.isTrialCancelled &&
    subscriptionData?.subscriptionInfo?.isSubscribed &&
    !subscriptionData?.subscriptionInfo?.isSubscribedExpired &&
    !subscriptionData?.subscriptionInfo?.isUnsubscribed &&
    !subscriptionData?.subscriptionInfo?.isSubscribeResumed
  );
};

export const checkIfUnsubscribeAndSubscriptionIsRunning = (
  subscriptionData: any,
) => {
  return (
    subscriptionData?.currentPlan?.status ===
      "Unsubscribed, subscription is running" &&
    subscriptionData?.userTrial?.isTrialCancelled &&
    subscriptionData?.userTrial?.isTrialExpired &&
    subscriptionData?.subscriptionInfo?.isSubscribed &&
    subscriptionData?.subscriptionInfo?.isUnsubscribed &&
    !subscriptionData?.subscriptionInfo?.isSubscribedExpired &&
    !subscriptionData?.subscriptionInfo?.isSubscribeResumed
  );
};
export const checkIfUnsubscribeAndSubscriptionAndUserInBackToFreePlan = (
  subscriptionData: any,
) => {
  return (
    subscriptionData.currentPlan.plan === "Free" &&
    subscriptionData?.currentPlan?.status === "Free" &&
    subscriptionData?.userTrial?.isTrialCancelled &&
    subscriptionData?.userTrial?.isTrialExpired &&
    subscriptionData?.subscriptionInfo?.isSubscribed === false &&
    subscriptionData?.subscriptionInfo?.isUnsubscribed &&
    subscriptionData?.subscriptionInfo?.isSubscribedExpired === false &&
    subscriptionData?.subscriptionInfo?.isSubscribeResumed === false
  );
};

export const GET_INDUSTRY_NAME = (text: string) => {
  if (text === "Agriculture") {
    return i18n("global.Agriculture");
  } else if (text === "Construction") {
    return i18n("global.Construction");
  } else if (text === "Education") {
    return i18n("global.Education");
  } else if (text === "Energy & Utilities") {
    return i18n("global.EnergyUtilities");
  } else if (text === "Environmental") {
    return i18n("global.Environmental");
  } else if (text === "Finance & Insurance Services") {
    return i18n("global.FinanceInsuranceServices");
  } else if (text === "Health & Safety") {
    return i18n("global.HealthSafety");
  } else if (text === "Health & Care") {
    return i18n("global.HealthCare");
  } else if (text === "Hospitality") {
    return i18n("global.Hospitality");
  } else if (text === "Information Technology") {
    return i18n("global.InformationTechnology");
  } else if (text === "Manufacturing") {
    return i18n("global.Manufacturing");
  } else if (text === "Mining") {
    return i18n("global.Mining");
  } else if (text === "Professional Services") {
    return i18n("global.ProfessionalServices");
  } else if (text === "Real Estate & Property Management") {
    return i18n("global.RealEstatePropertyManagement");
  } else if (text === "Retail") {
    return i18n("global.Retail");
  } else if (text === "Risk Management & Compliance") {
    return i18n("global.RiskManagementCompliance");
  } else if (text === "Telecommunications & Media") {
    return i18n("global.TelecommunicationsMedia");
  } else if (text === "Transport & Logistics") {
    return i18n("global.TransportLogistics");
  } else if (text === "All Industries") {
    return i18n("global.AllIndustries");
  }
};

export const INDUSTRIES = [
  "Agriculture",
  "Construction",
  "Education",
  "Energy & Utilities",
  "Environmental",
  "Finance & Insurance Services",
  "Health & Safety",
  "Health & Care",
  "Hospitality",
  "Information Technology",
  "Manufacturing",
  "Mining",
  "Professional Services",
  "Real Estate & Property Management",
  "Retail",
  "Risk Management & Compliance",
  "Telecommunications & Media",
  "Transport & Logistics",
];

export const colorMap = {
  "theme-gray-one": "#333333",
  "theme-gray-two": "#4F4F4F",
  "theme-gray-three": "#828282",
  "theme-primary-one": "#20639B",
  "theme-primary-two": "#2D9CDB",
  "theme-primary-three": "#56CCF2",
  "theme-green-one": "#219653",
  "theme-green-two": "#27AE60",
  "theme-green-three": "#6FCF97",
  "theme-red": "#EB5757",
  "theme-orange": "#F2994A",
  "theme-yellow": "#F2C94C",
  "theme-purple-one": "#9B51E0",
  "theme-purple-two": "#BB6BD9",
  "theme-pink": "#EAACCA",
};

export const homePagecategories = [
  {
    id: "construction_contracting",
    label: "Construction & Contracting",
    arabicLabel: "البناء والتشييد",
  },
  {
    id: "restaurants_cafes",
    label: "Restaurants & Cafes",
    arabicLabel: "المطاعم والمقاهي",
  },
  {
    id: "hotels_apartments",
    label: "Hotels & Apartments",
    arabicLabel: "الفنادق والشقق الفندقية",
  },
  { id: "manufacturing", label: "Manufacturing", arabicLabel: "التصنيع" },
  { id: "retail", label: "Retail", arabicLabel: "التجزئة" },
  { id: "itc", label: "ITC", arabicLabel: "تقنية المعلومات والاتصالات" },
  {
    id: "transportation_logistics",
    label: "Transportation & Logistics",
    arabicLabel: "النقل والخدمات اللوجستية",
  },
  {
    id: "health_services",
    label: "Health Services",
    arabicLabel: "الخدمات الصحية",
  },
  {
    id: "education_services",
    label: "Education Services",
    arabicLabel: "خدمات التعليم",
  },
  {
    id: "financial_services",
    label: "Financial Services",
    arabicLabel: "الخدمات المالية",
  },
  {
    id: "emergency_services",
    label: "Emergency Services",
    arabicLabel: "خدمات الطوائ",
  },
  {
    id: "cleaning_operation",
    label: "Cleaning & Operation",
    arabicLabel: "النظافه والتشغيل",
  },
  { id: "mining", label: "Mining", arabicLabel: "التعدين" },
  { id: "agriculture", label: "Agriculture", arabicLabel: "الزراعة" },
  {
    id: "printing_publishing",
    label: "Printing & Publishing",
    arabicLabel: "الطباعة والنشر",
  },
  { id: "other", label: "Other", arabicLabel: "أخرى" },
];
export const homePageContentTabs = [
  { id: "custom_forms", label: "Custom Forms", arabicLabel: "نماذج مخصصة" },
  {
    id: "instant_dispatch",
    label: "Instant Dispatch",
    arabicLabel: "إسناد لحظي",
  },
  {
    id: "digital_inspections",
    label: "Digital Inspections",
    arabicLabel: "فحوصات رقمية",
  },
  { id: "smart_reports", label: "Smart Reports", arabicLabel: "تقارير ذكية" },
  {
    id: "analytics_trends",
    label: "Analytics & Trends",
    arabicLabel: "تحليلات وإتجاهات",
  },
];

export const HomePageContentCards = [
  {
    id: "custom_forms",
    label: "Customizable Digital Forms",
    arabicLabel: "انشاء نماذج فحص مخصصة",
    details:
      "Transform traditional paper checklists and Excel sheets into smart inspection forms within minutes using the flexible form builder tool. Enhance inspection accuracy by requiring your team to attach photos and add comments based on their selected answers.",
    arabicDetails:
      "حوّل قوائم المراجعة الورقية وجداول اكسل التقليدية إلى نماذج فحص ذكية خلال دقائق باستخدام أداة إنشاء النماذج المرنة. عزز دقة الفحوصات عبر إلزام فريقك بإرفاق الصور وإضافة التعليقات بناءً على إجاباتهم المختارة.",
  },
  {
    id: "instant_dispatch",
    label: "Assign inspection tasks instantly",
    arabicLabel: "إسناد مهام الفحص لحظياً ",
    details:
      "Now you can update and assign digital inspection forms in seconds. You can specify inspectors, assign authorized personnel to view reports, and designate who has the authority to approve or reject them.",
    arabicDetails:
      "الآن يمكنك تحديث و اسناد نماذج الفحص الرقمية في لحظات، بإمكانك تحديد الفاحصين وتعيين المسؤولين المخولين بالاطلاع على التقارير، أيضاً بإمكانك تعيين من يملك صلاحية الموافقة على التقرير أو رفضه.",
  },
  {
    id: "digital_inspections",
    label: "Conduct inspections digitally",
    arabicLabel: "إجراء الفحوصات بشكل رقمي",
    details:
      "Our solutions turn tedious manual inspections into smooth digital processes, tracking real time and location. No more lost, delayed, unreadable, or disorganized paperwork.",
    arabicDetails:
      "حلولنا تحوّل مهام الفحص اليدوية الشاقة إلى عمليات سلسة و رقمية, وترصد الوقت والموقع الفعليين. لن تعاني بعد الآن من الأوراق المفقودة، أو المتأخرة, أو غير المقروءة، أو غير المنظمة.",
  },
  {
    id: "smart_reports",
    label: "Share custom smart reports",
    arabicLabel: "مشاركة تقارير ذكية مخصصة",
    details:
      "Save your valuable time and focus on your core business. Each inspection gives you a smart report highlighting fails, total score, and answered questions. Customize it with your brand and share it easily with clients or partners to boost collaboration and transparency.",
    arabicDetails:
      "وفّر وقتك الثمين وركز على أعمالك الأساسية. مع كل عملية فحص ستحصل على تقرير ذكي يرصد الإخفاقات، مجموع النقاط، وعدد الأسئلة المُجابة. خصص التقرير بهوية علامتك التجارية وشاركه بسهولة مع عملائك أو شركائك لتعزيز التعاون والشفافية.",
  },
  {
    id: "analytics_trends",
    label: "Analytics and trends dashboard ",
    arabicLabel: "لوحة مخصصة للتحليلات والاتجاهات",
    details:
      "Thanks to automatic syncing between mobile devices and the management platform, you now have a dashboard providing accurate real-time data and clear trends, plus exceptional insights. Identify recurring issues and resolve them quickly and easily.",
    arabicDetails:
      "بفضل التزامن التلقائي بين الأجهزة المحمولة ومنصة الإدارة، لديك الآن لوحة تحليلات تمنحك بيانات دقيقة واتجاهات محددة في الوقت الفعلي، بالإضافة إلى رؤى استثنائية. اكتشف الأخطاء المتكررة وقم بحلها بسرعة وسهولة.",
  },
  {
    id: "more_features",
    label: "More Features...",
    arabicLabel: "المزيد من الميزات ...",
    points: [
      {
        label: "Assign points per question and mark failure answers.",
        arabicLabel:
          "أضف قيمة لكل سؤال وحدد النقاط لكل إجابة. حدد الإجابات التي تُعتبر أخفاقًا.",
      },
      {
        label: "You can add an image or text help to the question.",
        arabicLabel: "بإمكانك اضافة مساعدة صورة أو محتوى نصي للسؤال.",
      },
      {
        label: "Be aware of the real-time location and time of the inspection.",
        arabicLabel: "كن على علم بالوقت والمكان الحقيقيين لإجراء الفحص.",
      },
      {
        label: "Full tracking of all report updates.reports.",
        arabicLabel: "رصد كامل للتحديثات التي تمت على التقارير.",
      },
      {
        label: "Tracking start time, inspection completion, and last update.",
        arabicLabel: "رصد وقت البدء وانهاء الفحص وآخر تحديث.",
      },
    ],
  },
];

export const HomePageServices = [
  {
    id: "secure_cloud_system",
    label: "Secure Cloud System",
    arabicLabel: "نظام سحابي آمن",
  },
  {
    id: "multiple_projects_support",
    label: "Supports Multiple Projects",
    arabicLabel: "يدعم المشاريع المتعددة ",
  },
  {
    id: "real_time_sync",
    label: "Real-time Sync Between Teams & Management",
    arabicLabel: "تزامن لحظي بين الفِرق والإدارة",
  },
  {
    id: "real_time_analytics",
    label: "Real-time Reports & Analytics",
    arabicLabel: "تقارير وتحليلات لحظية",
  },
  {
    id: "user_friendly_interfaces",
    label: "User-Friendly Interfaces",
    arabicLabel: "واجهات سهلة الاستخدام",
  },
  {
    id: "continuous_feature_development",
    label: "Continuous Feature Development",
    arabicLabel: "تطوير مستمر للمزايا",
  },
  {
    id: "advanced_role_control",
    label: "Advanced Role Control",
    arabicLabel: "تحكم متقدم للادوار والصلاحيات",
  },
  {
    id: "technical_support",
    label: "Technical Support",
    arabicLabel: "دعم فني",
  },
];

export const HomePageBusinessCards = [
  { id: "1", label: "Construction & Contracting", arabicLabel: "المقاولات" },
  { id: "2", label: "Hotels & Apartments", arabicLabel: "الضيافة" },
  { id: "3", label: "Restaurants & Cafes", arabicLabel: "الاطعمة" },
  { id: "4", label: "Health Services", arabicLabel: "الصحة" },
  { id: "5", label: "Manufacturing", arabicLabel: "التصنيع" },
  { id: "6", label: "Transportation & Logistics", arabicLabel: "اللوجستيات" },
  { id: "7", label: "ICT", arabicLabel: "التقنية" },
  { id: "8", label: "Retail", arabicLabel: "التجزئة" },
  { id: "9", label: "Hygiene", arabicLabel: "النظافة" },
  { id: "10", label: "Financial Services", arabicLabel: "المالية" },
  { id: "11", label: "Mining", arabicLabel: "التعدين" },
  { id: "12", label: "Education Services", arabicLabel: "التعليم" },
  { id: "13", label: "Agriculture", arabicLabel: "الزراعة" },
  { id: "14", label: "Emergency Services", arabicLabel: "الطوارئ" },
  { id: "15", label: "Printing & Publishing", arabicLabel: "النشر" },
];

export const HOME_PAGE_FAQS = (isArabic: boolean) => {
  const faqs = [
    {
      id: "1",
      question:
        isArabic ?
          "مالذي يمكنني الحصول عليه من منصة تمام؟"
        : "What can I get from Tamam Platform?",
      answer: {
        title:
          isArabic ?
            "منصتنا توفر لك مجموعة متكاملة من الأدوات والخدمات التي تساعدك في تحسين عمليات الفحص والتدقيق داخل منشأتك. باستخدام هذه المنصة، يمكنك الحصول على ما يلي:"
          : "Our platform offers a complete set of tools to streamline your inspection and auditing processes. Key features include:",
        points: [
          {
            heading: isArabic ? "نماذج إلكترونية ذكية:" : "Smart Forms: ",
            text:
              isArabic ?
                "أدوات مرنة وسهلة الاستخدام لإنشاء نماذج فحص مخصصة تلبي احتياجات منشأتك."
              : "Easily create customizable inspection forms.",
          },
          {
            heading: isArabic ? "توزيع سهل وفعال: " : "Instant Distribution: ",
            text:
              isArabic ?
                "إمكانية توزيع النماذج لحظياً على المستخدمين والموظفين بسرعة وسهولة."
              : "Quickly assign forms to users in real time.",
          },
          {
            heading:
              isArabic ? "جمع وتحليل البيانات: " : "Automated Data Analysis:",
            text:
              isArabic ?
                "جمع البيانات من الفحوصات وتحليلها بشكل آلي للحصول على تقارير دقيقة وشاملة."
              : " Collect and analyze inspection data effortlessly.",
          },
          {
            heading:
              isArabic ? "تقارير وتحليلات مفصلة: " : "Detailed Reports: ",
            text:
              isArabic ?
                "واجهة تحليلية تفاعلية تتيح لك الوصول إلى تقارير مفصلة وتحليلات بيانات دقيقة لتحديد الاتجاهات والرؤى."
              : "Access interactive dashboards and insightful analytics.",
          },
          {
            heading: isArabic ? "إدارة الموافقات:" : "Approval Workflow: ",
            text:
              isArabic ?
                "نظام مرن لإدارة عملية الموافقة على الفحوصات أو رفضها بسهولة."
              : "Manage approvals and rejections with ease.",
          },
          {
            heading: isArabic ? "تعزيز الكفاءة:" : "Improved Efficiency: ",
            text:
              isArabic ?
                "تحسين الكفاءة والسرعة في تنفيذ عمليات الفحص والتدقيق، مما يوفر الوقت والجهد."
              : "Save time and effort with faster processes.",
          },
          {
            heading: isArabic ? "دعم اتخاذ القرار: " : "Informed Decisions: ",
            text:
              isArabic ?
                "الحصول على رؤى دقيقة ومفصلة تساعدك في اتخاذ قرارات مستنيرة تستند إلى البيانات."
              : "Make better decisions based on accurate data.",
          },
        ],
        conclusion:
          isArabic ?
            "باختصار، منصة تمام توفر لك بيئة متكاملة لتحسين عمليات الفحص والتدقيق، مما يسهم في رفع كفاءة عمليات الفحص وتحقيق الإمتثال والجودة بكفاءة وفعالية."
          : "In short, Tamam helps you boost inspection efficiency, ensure compliance, and improve quality with ease.",
      },
      isActive: false,
    },
    {
      id: "2",
      question:
        isArabic ?
          "هل يجب علي أن أدفع مقابل إستخدام منصة تمام؟"
        : "Do I have to pay to use Tamam Platform?",
      answer: {
        title:
          isArabic ?
            "خدمة منصة تمام مجانية وتوفر كل ما تحتاجه لبدء رحلتك نحو التحسين المستمر، بما في ذلك دعوة فريق يصل إلى 10 أعضاء والتعاون معهم، وإجراء عمليات الفحص وتوليد تقارير إحترافية وإمكانية مشاركتها، بالإضافة إلى التواصل الفعّال مع أعضاء فريقك. "
          : "Tamam is a free platform that lets you invite up to 10 team members, conduct inspections, generate and share professional reports, and collaborate effectively — all to support your continuous improvement journey.",
      },
      isActive: false,
    },
    {
      id: "3",
      question:
        isArabic ?
          "هل يمكنني إستيراد قوائم المراجعة والنماذج الموجودة لدي؟"
        : "Can I import existing checklists and forms?",
      answer: {
        title:
          isArabic ?
            "أداة إنشاء النماذج الرقمية ستتيح لك نسخ النماذج وقوائم المراجعة الخاصة بك, ومن ثم لصقها بسهولة وإعادة تنسيقها حسب إحتياجاتك. مع ذلك فريق تمام على استعداد لمساعدتك بتحويل نماذجك الورقية الى رقمية. "
          : "The form builder lets you easily copy, paste, and customize your checklists. Tamam’s team is also ready to help you digitize your paper forms.",
      },
      isActive: false,
    },
  ];
  return faqs;
};
